import { getToken } from '../Context/User.context';
import API from './index';

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

/** Liste les pièces jointes d'un vol. */
export const list = (flightId: number) =>
  API.get(`/flight/${flightId}/attachment`, { headers: authHeaders() });

/**
 * Envoie un ou plusieurs fichiers.
 * Ne PAS fixer manuellement le Content-Type : le navigateur ajoute le
 * boundary multipart pour un FormData.
 */
export const upload = (flightId: number, files: FileList) => {
  const formData = new FormData();
  Array.from(files).forEach(file => formData.append('files', file));
  return API.post(`/flight/${flightId}/attachment`, formData, { headers: authHeaders() });
};

/** Télécharge une pièce jointe (blob). */
export const download = (flightId: number, attachmentId: number) =>
  API.get(`/flight/${flightId}/attachment/${attachmentId}`, {
    responseType: 'blob',
    headers: authHeaders(),
  });

/** Télécharge toutes les pièces jointes du vol dans un zip `flight_<id>.zip`. */
export const downloadZip = (flightId: number) =>
  API.get(`/flight/${flightId}/attachment/zip`, {
    responseType: 'blob',
    headers: authHeaders(),
  });

/** Supprime une pièce jointe. */
export const remove = (flightId: number, attachmentId: number) =>
  API.delete(`/flight/${flightId}/attachment/${attachmentId}`, { headers: authHeaders() });
